import React from "react"
const StatusButton = ({ setStatus, status, statusValue }) => {
    return (
        <button className="btn btnHeight me-2 px-4"
            style={{
                background: statusValue == status ? "#556ee6" : "#f4f4f4",
                color: statusValue == status ? "#FFF" : "#495057",
                marginTop: "5px",
                fontWeight:"500",
            }}
            onClick={() => { setStatus(status) }}  >
            {status}
        </button>
    )
}

export default StatusButton